interface Props {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export default function AdminCard({ title, children, actions }: Props) {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
        <h3 className="text-sm font-bold text-[#071A2E]">{title}</h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div className="px-6 py-5">{children}</div>
    </div>
  );
}
